import React, { useMemo } from "react";
import { Sticky } from "@skbkontur/react-ui";

import { EMBEDDED_PANEL_HEIGHT, PANEL_INDENT } from "../../../Panel/Panel.styles";
import { ERROR_COUNTERS_HEIGHT, ERROR_COUNTERS_INDENT } from "../../WidePanelLog/WidePanelLog.styles";
import { uuid } from "../../../../../../../Common/UUID";

import { ErrorGroupHeader, ErrorGroupHeaderProps } from "./ErrorGroupHeader";
import { VisibleStickyHeader } from "./HeaderVisibility";

export interface ErrorGroupHeaderStickyProps extends Omit<ErrorGroupHeaderProps, "fixed"> {
    additionalHeaderOffset?: number;
}

export const ErrorGroupHeaderSticky = (props: ErrorGroupHeaderStickyProps) => {
    const additionalOffset = props.additionalHeaderOffset ?? 0;
    const offset =
        EMBEDDED_PANEL_HEIGHT + PANEL_INDENT + ERROR_COUNTERS_HEIGHT + ERROR_COUNTERS_INDENT + additionalOffset;
    const tid = useMemo(() => "group-header-" + uuid(), []);

    if (!props.title) {
        return null;
    }

    return (
        <Sticky side="top" offset={offset}>
            {fixed => (
                <VisibleStickyHeader fixed={fixed} tid={props.tid ?? tid}>
                    <ErrorGroupHeader fixed={fixed} tid={props.tid} title={props.title} hint={props.hint} />
                </VisibleStickyHeader>
            )}
        </Sticky>
    );
};
